import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class PersonCreateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_CLEAR
    });

    this.component.pageTemplate = this.component.props.app.templateForPersonCreatePage;

    this.component.props.dispatch({
      type: Constants.PERSON_CREATE_PAGE_TEMPLATE_CLEAR
    });

    let state: any = {};
    if (this.component.props.app.lookupSearchText) {
      // const currentLookupSearchTextArr = this.component.props.app.lookupSearchText.split(" ");

      // let firstName = "";
      // let lastName = this.component.props.app.lookupSearchText;

      // if (currentLookupSearchTextArr.length > 1) {
      //   firstName = currentLookupSearchTextArr[0];
      //   lastName = currentLookupSearchTextArr.slice(1, currentLookupSearchTextArr.length).join(" ");
      // }

      state = {
        firstName: this.component.props.app.lookupSearchText,
        lastName: "",
        hasModifiedData: true
      };
    }

    let personCreateDataToBeSaved: any = {};

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdCompany = this.component.props.app.savedDataBeforeRedirecting.createdCompany &&
      this.component.props.app.savedDataBeforeRedirecting.createdCompany;

      personCreateDataToBeSaved = {...this.component.props.app.savedDataBeforeRedirecting.personCreateDataToBeSaved};

      if (!!personCreateDataToBeSaved.counterpartyIbanForPayment) {
        personCreateDataToBeSaved.mainBankAccountId = personCreateDataToBeSaved.counterpartyIbanForPayment;
      }

      if (!!createdCompany) {
        personCreateDataToBeSaved.company = createdCompany;
        personCreateDataToBeSaved.hasModifiedData = true;
      }
    }

    this.component.setState({
      ...personCreateDataToBeSaved,
      ...state,
      firstName: personCreateDataToBeSaved?.name || personCreateDataToBeSaved?.firstName || this.component.props.app?.lookupSearchText,
      lastName: personCreateDataToBeSaved?.name ? "" : personCreateDataToBeSaved?.lastName

    }, () => {
      this.component.props.dispatch({
        type: Constants.LOOKUP_SEARCHTEXT_CLEAR
      });
    });
  }
}

export default new PersonCreateWillMount();
